import { VisuallyHidden } from "@radix-ui/react-visually-hidden"
import classNames from "classnames"
import React from "react"
import { Drawer } from "vaul"

import { PayflexLogo } from "./PayflexLogo"
import PayflexStep from "./PayflexStep"
import { PayflexTerm } from "./PayflexTerm"

const PAYFLEX_STEPS = [
  {
    stepCount: 1,
    title: "Select your payment plan",
    label: "3 or 4 instalments",
  },
  {
    stepCount: 2,
    title: "Pay in 3",
    label: "pay over 3 paydays interest free",
    altTitle: "Pay in 4",
    altLabel: "pay in 4 instalments over 6 weeks interest free",
  },
  {
    stepCount: 3,
    title: "Flex! get approved",
    label: "Pay your first instalment today and get what you want now",
  },
]

const PAYFLEX_TERMS = [
  {
    term: "You must be over 18 years old",
  },
  {
    term: "You must have a valid South African ID",
  },
  {
    term: "You must have a debit/credit card issued by Mastercard, Visa or Amex",
  },
]

const SectionSeparator = ({
  size = "medium",
}: {
  size?: "small" | "medium"
}) => {
  return (
    <div
      className={classNames("my-10 w-full bg-payflex-navy", {
        "h-[2px]": size === "medium",
        "h-[1px]": size === "small",
      })}
    />
  )
}
/**
 * NOTE: this component does not follow our design system.
 *
 * The 'OpenSans' font will be loaded when this component is opened.
 */
export const PayflexModal = () => {
  return (
    <Drawer.Portal>
      <Drawer.Overlay className="fixed -top-28 bottom-0 left-0 right-0 z-50 bg-black/30" />
      <VisuallyHidden>
        <Drawer.Description>Payflex information</Drawer.Description>
      </VisuallyHidden>
      <Drawer.Content className="fixed inset-0 z-50 flex items-center justify-center">
        <div className="relative z-20 max-h-[90vh] w-[90vw] overflow-y-auto rounded-[16px] bg-white px-20 pb-24 pt-7 sm:max-w-[900px] sm:pt-[58px]">
          <Drawer.Trigger>
            <img
              className="absolute right-20 top-20 h-[26px] w-[24px]"
              src="/icons/payflex-close-icon.svg"
              alt="Close Dialog"
            />
          </Drawer.Trigger>
          <div>
            <Drawer.Title>
              <div className="flex flex-row items-center justify-between gap-24 sm:gap-[93px]">
                <PayflexLogo size="large" variant="light" />
                <div className="px-32 font-open-sans text-body-sm font-bold">
                  <p className="text-payflex-navy">
                    NO&nbsp;INTEREST. NO&nbsp;FEES.
                  </p>
                  <p className="text-payflex-purple">THIS IS SHOPPING.</p>
                </div>
              </div>
            </Drawer.Title>

            <SectionSeparator />
            <div className="my-24 ml-8 flex flex-col gap-[11px] sm:my-[43px] sm:ml-[10%] md:ml-[30%] md:flex-col md:gap-20">
              {PAYFLEX_STEPS.map((step) => (
                <PayflexStep key={step.stepCount} {...step} />
              ))}
            </div>
            <SectionSeparator />
            <div className="ml-8 flex flex-col justify-center gap-[22px] py-8 sm:ml-[10%] md:ml-0 md:flex-row md:justify-between">
              {PAYFLEX_TERMS.map((term) => (
                <PayflexTerm key={term.term} {...term} />
              ))}
            </div>
            <SectionSeparator size="small" />

            <div className="mt-[30px] flex w-full justify-center gap-4 text-[10px]">
              <p className="font-open-sans text-[10px] font-semibold text-payflex-purple">
                Still want more information?
              </p>
              <a
                className="font-open-sans font-semibold text-payflex-navy underline"
                href="https://payflex.co.za/how-it-works/"
                target="_blank"
                rel="noreferrer nofollow"
              >
                Click here
              </a>
            </div>
          </div>
        </div>
        <Drawer.Close className="fixed inset-0" />
      </Drawer.Content>
    </Drawer.Portal>
  )
}
